(() => {
  const storageKey = 'amf-customer-login-state';
  const loginPendingKey = 'amf-customer-login-pending';
  const body = document.body;

  if (!body) return;

  const currentState = body.dataset.customerLoggedIn === 'true';
  let previousState = null;
  let loginPending = false;

  try {
    previousState = window.localStorage.getItem(storageKey);
    loginPending = window.localStorage.getItem(loginPendingKey) === 'true';
  } catch (error) {
    return;
  }

  const wasLoggedIn = previousState === 'true';
  const shouldShowLoginToast = currentState && (loginPending || wasLoggedIn === false);
  const shouldShowLogoutToast = currentState === false && wasLoggedIn;

  if (shouldShowLoginToast) {
    showToast('login');
  } else if (shouldShowLogoutToast) {
    showToast('logout');
  }

  try {
    if (shouldShowLoginToast && loginPending) {
      window.localStorage.removeItem(loginPendingKey);
    }

    window.localStorage.setItem(storageKey, String(currentState));
  } catch (error) {
    return;
  }

  function showToast(type) {
    const toast = document.createElement('div');
    toast.className = `auth-status-toast auth-status-toast--${type}`;
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');

    const message =
      type === 'login' ? 'You are now logged in.' : 'You have been logged out.';

    toast.innerHTML = `
      <span class="auth-status-toast__icon" aria-hidden="true"></span>
      <p class="auth-status-toast__message">${message}</p>
    `;

    document.body.appendChild(toast);

    window.requestAnimationFrame(() => {
      toast.classList.add('is-visible');
    });

    window.setTimeout(() => {
      toast.classList.remove('is-visible');

      window.setTimeout(() => {
        toast.remove();
      }, 250);
    }, 5000);
  }
})();
